<div class="row">
    <div class="col-sm-12" style="display: flex; justify-content: space-between;">
        <h3 class="col-sm-5"> Validation du {{bc.fValide === 2 ? bc.code : "Cxxxxxxxxxx"}} {{this.bc.societe ? '(' + this.bc.societe.code + ')' : ''}}</h3>
        <div class="col-sm-7" style="justify-content: space-between;">
        
            <button color="default" mat-raised-button type="button" (click)="close()">
                <mat-icon>arrow_back</mat-icon>Retour à la liste
            </button>
            <button [color]="'primary'" mat-raised-button
                type="button" (click)="openCycleValidation()">
                <mat-icon>share</mat-icon>Cycle de validation
            </button>
            <app-pdf-bc [bc]="bc">Imprimer</app-pdf-bc>
            <button color="warn" *ngIf="!this.bc.bBloque" mat-raised-button type="button" (click)="bloquer()">
                <mat-icon>lock</mat-icon>Bloquer
            </button>

            <button color="success" *ngIf="this.bc.bBloque" mat-raised-button type="button" (click)="debloquer()">
                <mat-icon>lock_open</mat-icon>Débloquer
            </button>

            <button color="success" *ngIf="!this.bc.bBloque" mat-raised-button type="button" (click)="validate()">
                <mat-icon>check</mat-icon>Valider
            </button>
            <button color="danger" *ngIf="!this.bc.bBloque" mat-raised-button type="button" (click)="refus()">
                <mat-icon>not_interested</mat-icon>Retour pour complément
            </button>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-sm-10 padding-0">
        <div>
            <app-bc-form [form]="bcForm" [detailBcInfo]="detailBcInfo" [amountHT]="bcLineHTs"
                [amountTTC]="bcLineTTCs" [amountTVA]="bcLineTVAs">
            </app-bc-form>
            <br>
        </div>
    </div>
    <div class= "col-sm-2 padding-0">
        <app-cycles-bc [cycles]="bc.cycleBcs" [title]="bc.fValide === 2 ? bc.code : 'Cxxxxxxxxxx'"></app-cycles-bc>
    </div>
    <mat-card  [ngClass]="childHeight < 285 ? 'col-sm-12' : 'col-sm-10'">
        <mat-card-content>
            <app-fixed-bc-line-list-validation 
                [form]="bcForm">
            </app-fixed-bc-line-list-validation>
        </mat-card-content>
    </mat-card>
</div>